import { Component, ViewEncapsulation } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { param } from "jquery";

@Component({
    selector: 'app-export-log-action-renderer',
    templateUrl: './export-log-action-renderer.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class ExportLogActionRendererComponent {
  Xeroaction : string = "XeroAction";
  viewdetailaction : string = "ViewDetailAction";
  multiformatdownloadaction : string = "MultiFormatDownloadAction";
  actionButtons: any[] = [];
  params: ICellRendererParams;
  data : any ={};
  constructor() {

  }

  onUserAction(action) {
    this.params.data.userAction = action;
    this.params.node.setData(this.params.data);
    this.params.eGridCell.click();
  }


  initilize(params: ICellRendererParams) {
    if (params && params.data) {
      this.params = params;
      this.data = params.data;
      this.actionButtons = JSON.parse(JSON.stringify(params.colDef?.headerComponentParams));
    }
    else {
      this.actionButtons = [];
    }
  }


  // called on init
  agInit(params: any): void {
    this.initilize(params);
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }
}
